import { createFileRoute, redirect } from "@tanstack/react-router";

// Help Center is now the DB-backed FAQ; redirect so old /help links survive.
export const Route = createFileRoute("/help/")({
  beforeLoad: () => {
    throw redirect({ to: "/faq" });
  },
});
